import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericTablePage from '../components/GenericTablePage';
import { GridColDef } from '@mui/x-data-grid';

const AreasPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  
  const columns: GridColDef[] = [
    { 
      field: isArabic ? 'translation' : 'area', 
      headerName: t('areas.area'), 
      flex: 1, 
      minWidth: 200 
    },
    { 
      field: isArabic ? 'area' : 'translation', 
      headerName: isArabic ? t('areas.english') : t('areas.translation'), 
      flex: 1, 
      minWidth: 200 
    },
  ];

  const fields = [
    { 
      name: 'area', 
      label: t('areas.area'), 
      type: 'text' as const, 
      required: true 
    },
    { 
      name: 'translation', 
      label: t('areas.translation'), 
      type: 'text' as const, 
      required: true 
    },
    { 
      name: 'city_id', 
      label: t('areas.city'), 
      type: 'select' as const,
      required: true,
      foreignKey: {
        table: 'cities',
        valueField: 'id',
        labelField: isArabic ? 'translation' : 'city'
      }
    },
  ];

  return (
    <GenericTablePage 
      tableName="areas"
      title={t('areas.title')}
      columns={columns}
      fields={fields}
      selectQuery="*, cities:city_id(city)"
    />
  );
};

export default AreasPage;
